import { Modal } from "react-bootstrap";
import Button, { ButtonProps } from "../Button";
import * as app from "../../services/AppService"
import React, { ReactElement, useState } from "react" 
import store from "../../store"
import { hideMsgDialog } from "../../store/msgDialog"
import Input from "../Input"
import { useEffect } from "react";

export interface MsgDialogProps {
    show: boolean;
    extraButtons?: ButtonProps[];
    label?: string;
    confirmMsg?: string;
    body?: string | ReactElement | ReactElement[];
    title?: string;
    closeLabel?: string;
    defValue?: string;
    onClose?: () => void;
    ok?: (val: string) => void;
}

export default function MsgDialog(props: MsgDialogProps) {

    const [state, setState] = useState("")

    function Close() {
        store.dispatch(hideMsgDialog())
        if (props.onClose && typeof (props.onClose) == "function")
            props.onClose();
    }
    function Ok() {
        store.dispatch(hideMsgDialog())
        if (props.ok && typeof (props.ok) == "function")
            props.ok(state)
        setState("")
    }

    useEffect(() => {
        if (props.defValue)
            setState(props.defValue);
    }, [props.defValue])

    let Title = props.title;
    let Body = props.body;
    let CloseLabel = props.closeLabel ? props.closeLabel : Body === "MsgCompleteProcess" ? "Ok" : "Close";
    let IsError = false;
    if (!props.title)
        Title = Body === "MsgUpdateComplete" || Body === "MsgCompleteProcess" ? "success" : "Error";

    if (!Body) {
        Body = app.translate("Error_Operation");
    }
    if (Title === "Error" || Title === "Validation") IsError = true;
    if (typeof (Body) === "string" && ["MsgUpdateComplete", "MsgCompleteProcess"].includes(Body))
        Body = app.translate(Body);
    return (
        <Modal backdrop="static" data-bs-theme={app.getCookie("colorMode", window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light")} show={props.show} onHide={Close} style={{ direction: app.translate("Lang") === "ar" ? "rtl" : "ltr" }}>
            <Modal.Header onClick={Close} className={`py-2 border-bottom text-primary-emphasis ${IsError ? "bg-danger" : Title === "Warning" ? "bg-warning" : "bg-body-tertiary"}`}>
                <Modal.Title>{app.translate(Title)}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-body-tertiary text-dark-emphasis">
                <>{(!props.confirmMsg && Body)}</>
                {(props.confirmMsg && <>
                    <span>{props.confirmMsg}</span>
                    <Input label={props.label} model={state}
                        onChange={state => setState(state)} />
                </>)}
            </Modal.Body>
            <Modal.Footer className="bg-body-tertiary border-top py-2">
                <div className=" me-auto">
                    {props.extraButtons && props.extraButtons.map((btn, i) => {
                        return <Button elmKey={i} class={'btn btn-primary mx-1 ' + btn.class} clicked = { btn.clicked } label = { btn.label } icon = { btn.icon } />
                    })}
                </div>
                <Button class={CloseLabel === "Ok" ? "btn btn-success" : "btn-danger"} clicked={Close} label={CloseLabel} icon="close-1" />
                {props.ok && <Button class={`btn btn-${Title === "Warning" ? "warning" : "success"}`} clicked={Ok} label="Ok" icon="done-1" />}

            </Modal.Footer>
        </Modal>
    );
} 